import ReactDOM from 'react-dom';
import { MaybeLeadGenWidget } from '../emailSignup/MaybeLeadGenWidget.tsx';

const showWidget = () => {
    ReactDOM.render(
        <MaybeLeadGenWidget leadGenEnabled={window.leadGenEnabled} minimizedLeadGenEnabled={window.minimizedLeadGenEnabled} targetElementId={'proposal-supporting-details'} />,
        document.getElementById('lead-gen-holder'),
    );
};

/**
 * Top-level setup for "lead gen", the 2024 version of EmailContactSignupWidget. A tool with which users who haven't
 * donated can sign up to receive emails from us.
 */
export const main = () => {
    $(document).ready(function () {
        showWidget();
    });
};
